import { useEffect, useState } from "react";

function shouldReduceMotion() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return true;
  }
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export default function useParallaxScroll() {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (shouldReduceMotion() || typeof window === "undefined") {
      return undefined;
    }

    let frame = 0;
    const update = () => {
      frame = 0;
      setOffset(window.scrollY || 0);
    };
    const onScroll = () => {
      if (!frame) {
        frame = window.requestAnimationFrame(update);
      }
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame) {
        window.cancelAnimationFrame(frame);
      }
    };
  }, []);

  return {
    hero: { transform: `translate3d(0, ${Math.min(offset * -0.025, 0)}px, 0)` },
    mid: { transform: `translate3d(0, ${Math.min(offset * -0.015, 0)}px, 0)` },
  };
}
